import axios from "axios";
// import router from '../router/index'

/**
 * 輔助函式：從 document.cookie 中讀取指定的 cookie 值
 * @param {string} name - 要讀取的 cookie 名稱
 * @returns {string|null}
 */
function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

/**
 * 工廠函式：建立並回傳一個已配置好所有通用攔截器的 Axios 實例
 * @param {object} config - 傳遞給 axios.create 的配置物件 (e.g., baseURL, timeout)
 * @returns {import('axios').AxiosInstance}
 */
function createApiClient(config) {
  // 1. 根據傳入的設定建立實例
  const apiClient = axios.create(config);

  // 2. 應用所有通用的攔截器
  // --- 請求攔截器 ---
  apiClient.interceptors.request.use(
    (config) => {
        // [整合邏輯 1]: 條件式 withCredentials
        // 檢查 API 路徑是否「不是」登入路徑
        if (config.url !== 'cms/login') {
            config.withCredentials = true;
        }

        // [整合邏輯 2]: CSRF Token 處理
        const unsafeMethods = ['post', 'put', 'patch', 'delete'];
        if (unsafeMethods.includes(config.method)) {
            config.headers['X-CSRFToken'] = getCookie('csrftoken');
        }

        // [整合邏輯 3]: NEED_PERMISSION 處理
        // 確保 config.data 存在才進行操作，避免 GET 請求出錯
        if (config.data) {
            const NEED_PERMISSION = config.data.NEED_PERMISSION;
            delete config.data.NEED_PERMISSION;

            if (NEED_PERMISSION) {
                const userData = localStorage.getItem('cc-cms');
                if (userData) {
                    const { permission } = JSON.parse(userData);
                    config.data["permission"] = permission;
                }
            }
        }

        return config;
    },
    (error) => Promise.reject(error)
  );

  // --- 回應攔截器 ---
  apiClient.interceptors.response.use(
    (res) => {
      // 直接回傳後端 API 的 data 內容
      return res.data;
    },
    (err) => {
      // [整合邏輯 4]: 統一的錯誤回應處理
      // 使用 optional chaining (?.) 避免在網路錯誤時 (err.response 不存在) 拋出異常
      const ErrorCode = err.response?.status;
      switch (ErrorCode) {
        case 400:
          console.log(`${ErrorCode} 資料錯誤`);
          break;
        case 403:
          console.log(`${ErrorCode} 權限不足`);
          // router.push('/403');
          break;
        case 404:
          console.log(`${ErrorCode} 你要找的頁面不存在`);
          // router.push('/404');
          break;
        case 500:
          console.log(`${ErrorCode} 伺服器內部錯誤`);
          // router.push('/500');
          break;
        default:
          console.log(err.message);
      }
      return Promise.reject(err);
    }
  );
  return apiClient;
}



// 使用我們強大的工廠函式來建立主要的 instance
const instance = createApiClient({
    baseURL: process.env.NODE_ENV === 'production' ? '' : process.env.VUE_APP_BACKEND,
    timeout: 30000,
});


// 導出您原本的 API 呼叫函式，它現在會使用上面建立的、功能齊全的 instance
export default function(method, url, data = null, response) {
  method = method.toLowerCase();
  switch (method) {
    case "post":
      return instance.post(url, data);
    case "get":
      return instance.get(url, { params: data });
    case "delete":
      return instance.delete(url, data);
    case "put":
      return instance.put(url, data, response);
    default:
      console.log(`未知的 method: ${method}`);
      return false;
  }
}